import { useFetchDashboardData } from '../use-fetch-dashboard';
import { useLateArrivals } from './charts/use-late-arrivals';
import { useStaffByOvertimePercent } from './charts/use-staff-by-overtime-percent';
import { useTopStaffByOvertime } from './charts/use-top-staff-by-overtime';
import { useTotalWorkingTime } from './charts/use-total-working-time';
import { useWorkdayBalance } from './charts/use-work-day-balance';

export const useDashboardStaff = () => {
  useFetchDashboardData([
    'total_work_time',
    'overtime_percent',
    'top_late_employees',
    'top_overtime_employees',
    'overtime_heat_map',
    'deviation_balance',
  ]);

  return {
    chartsData: [
      useTotalWorkingTime(),
      useStaffByOvertimePercent(),
      // useTopStaffByDelays(),
      useTopStaffByOvertime(),
      useLateArrivals(),
      useWorkdayBalance(),
    ],
  };
};
